<template>
  <v-card flat>
    <v-card-text color="grey lighten-3">
      <v-list>
        <v-card
          outlined
          :loading="loadUpload"
          :disabled="loadUpload"
          class="mb-4">
          <v-card-title class="d-flex justify-space-between grey lighten-4">
            <span class="font-weight-medium">{{ consulta.nomeExame }} ({{ consulta.nomeUnidade }})</span>
          </v-card-title>

          <v-card-text class="pt-0 px-4" disabled>
            <v-textarea
              v-model="consulta.obsLaudoTec"
              label="Observação"
              outlined
              rows="2"
              class="mt-2"
              :disabled="consulta.status != ''"
            ></v-textarea>

            <v-file-input
              v-model="files"
              label="Selecione arquivos"
              chips
              multiple
              accept="image/*,application/pdf"
              prepend-icon="mdi-paperclip"
              @change="preViewFiles"
              class="mt-2"
              :disabled="consulta.status != ''"
            ></v-file-input>

            <v-chip-group
              v-if="consulta.files.length > 0"
              class="mt-3"
              column
            >
              <v-chip
                v-for="(file, index) in consulta.files"
                :key="file.name"
                :close="consulta.status == ''"
                @click="openFile(file.url)"
                @click:close="removeFile(index)"
              >
                {{ file.name }}
              </v-chip>
            </v-chip-group>
          </v-card-text>

          <v-card-actions class="d-flex justify-end pt-0">
            <v-btn text color="orange" @click="$emit('voltar')"><v-icon left>undo</v-icon> voltar</v-btn>
            <v-btn color="success" :disabled="consulta.files.length ==  0 || consulta.status != ''" text @click="exibirDialogConfirmacao">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-list>
    </v-card-text>

    <!-- Dialog para pré-visualização -->
    <v-dialog v-model="dialogPreview" max-width="800px" persistent>
      <v-card>
        <v-card-title>Por favor, confirme as informações.</v-card-title>
        <v-stepper v-model="e1">
          <v-stepper-header>
            <template v-for="n in steps">
              <v-stepper-step
                :key="`${n}-step`"
                :complete="e1 > n"
                :step="n"
              >
                Anexo{{ n }}
              </v-stepper-step>

              <v-divider
                v-if="n !== steps"
                :key="n"
              ></v-divider>
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content
              v-for="n in steps"
              :key="`${n}-content`"
              :step="n"
            >
              <v-card-text>
                <template v-if="previewFileObjects[n-1] && previewFileObjects[n-1].file.type.includes('image')">
                  <v-img :src="previewFileObjects[n-1].url" max-width="100%" height="400px"></v-img>
                </template>

                <template v-else-if="previewFileObjects[n-1] && previewFileObjects[n-1].file.type === 'application/pdf'">
                  <embed :src="previewFileObjects[n-1].url" type="application/pdf" width="100%" height="400px" />
                </template>

                <template v-else-if="previewFileObjects[n-1] && previewFileObjects[n-1].file.type === 'application/dcm'">
                  <p>Favor confira o arquivo DICOM em seu programa nativo</p>
                </template>

                <template v-else>
                  <p>Tipo de arquivo não suportado para pré-visualização.</p>
                </template>
              </v-card-text>
            </v-stepper-content>
          </v-stepper-items>
          <v-card-actions>
            <v-spacer/>
            <v-btn text color="red" @click="dialogPreview = false, previewFileObjects = []">
              Cancelar
            </v-btn>
            <v-btn
              v-if="e1 > 1"
              color="primary"
              @click="e1 = e1 -1"
            >
              Anterior
            </v-btn>

            <v-btn
              v-if="e1 < steps"
              color="primary"
              @click="nextStep()"
            >
              Próximo
            </v-btn>
            <v-btn
              v-if="e1 == steps"
              color="success"
              @click="dialogPreview = false, confirmFiles()"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-stepper>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogConfirmaLaudo"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Deseja continuar?
        </v-card-title>
        <v-card-text>Uma vez cadastrado o laudo, <b>não</b> será mais possível realizar alterações, pois o mesmo estará liberado para o médico.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="dialogConfirmaLaudo = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialogConfirmaLaudo = false, salvarLaudo()"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar de sucesso -->
    <v-snackbar
      v-model="successSnackbar"
      bottom
      :timeout="1500"
      color="success"
    >
      Laudo salvo com sucesso!
      <template #action>
        <v-btn text @click="successSnackbar = false">OK</v-btn>
      </template>
    </v-snackbar>

    <!-- Snackbar de erro -->
    <v-snackbar
      v-model="errorSnackbar"
      bottom
      :timeout="1500"
      color="error"
    >
      Ocorreu um erro ao salvar o laudo.
      <template #action>
        <v-btn text @click="errorSnackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import medicoService from '../../services/medico.service'

export default {
  props: {
    ficha: Object,
    consulta: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      user: '',
      files: [],
      dadosPaciente: {},
      dialogPreview: false,
      previewFileObjects: [],
      e1: '',
      steps: 0,
      loadUpload: false,
      dialogConfirmaLaudo: false,
      errorSnackbar: false,
      successSnackbar: false
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.retornarInformacoesPacienteOs()
    this.buscarLaudos()
  },
  methods: {
    handleFiles () {
      this.consulta.files.push(...this.files.filter(newFile =>
        !this.consulta.files.some(existingFile => existingFile.name === newFile.name)
      ))
      this.files = []
      this.previewFileObjects = []
    },
    removeFile (index) {
      this.consulta.files.splice(index, 1)
    },
    preViewFiles () {
      this.steps = this.files.length
      if (this.files && this.files.length > 0) {
        this.files.forEach(file => {
          const fileUrl = URL.createObjectURL(file)
          this.previewFileObjects.push({ file, url: fileUrl })
        })
        this.e1 = 1
        this.dialogPreview = true
      }
    },
    confirmFiles () {
      this.handleFiles()
    },
    retornarInformacoesPacienteOs () {
      medicoService.medico.retornarInformacoesPacienteOs(this.ficha.idOrdemServico).then(r => {
        if (r.status == 200) {
          this.dadosPaciente = r.data
        }
      })
    },
    nextStep () {
      this.e1 = this.e1 + 1
    },
    exibirDialogConfirmacao () {
      this.dialogConfirmaLaudo = true
    },
    async processFiles () {
      const filesArray = this.consulta.files

      for (let i = 0; i < filesArray.length; i++) {
        const item = filesArray[i]

        if (!('lastModified' in item) && item.name && item.url) {
          try {
            const response = await fetch(item.url)

            if (!response.ok) {
              console.error('Erro ao baixar arquivo: ', item.url, response.status, response.statusText)
              return
            }

            const blob = await response.blob()
            const file = new File([blob], item.name, { type: blob.type })
            filesArray[i] = file
          } catch (error) {
            console.error('Erro ao baixar arquivo:', item.url, error)
          }
        }
      }
    },
    async salvarLaudo () {
      this.loadUpload = true
      await this.processFiles()
      var data = new FormData()

      data.append('idExameOs', this.consulta.idexamesos)
      data.append('idPaciente', this.ficha.idPaciente)
      data.append('idEmpresa', this.user.idEmpresa)
      data.append('idUnidadeNegocio', this.user.idUnidade)
      data.append('idPrestadorExecutante', this.user.idPrestador == null ? 95 : this.user.idPrestador)
      data.append('idUsuario', this.user.id)
      data.append('obsLaudoTec', this.consulta.obsLaudoTec)

      this.consulta.files.forEach((file, idx) => {
        data.append(`files`, file)
      })

      medicoService.medico.cadastrarLaudoTec(data).then(r => {
        if (r.status == 200) {
          this.buscarLaudos()
          this.successSnackbar = true
        } else {
          this.errorSnackbar = true
        }
      }).finally(() => {
        this.dialogConfirmaLaudo = false
        this.loadUpload = false
        this.$emit('voltar')
      })
    },
    buscarLaudos () {
      var data = [
        { idExamesOs: this.consulta.idexamesos,
          idPaciente: this.ficha.idPaciente,
          idEmpresa: this.user.idEmpresa,
          idPrestadorExecutante: this.user.idPrestador == null ? 95 : this.user.idPrestador
        }]

      var queryString = `data=${encodeURIComponent(JSON.stringify(data))}`
      console.log('----', queryString, data, this.consulta)

      medicoService.medico.listarLaudosTecByIdsExamesOsTec([queryString]).then(r => {
        if (r.status == 200) {
          const laudo = r.data[0]
          this.consulta.obsLaudoTec = laudo.obsLaudoTec
          this.consulta.status = laudo.status
          this.consulta.files = laudo.files
        }
      })
    },
    openFile (url) {
      if (url) {
        window.open(url, '_blank')
      } else {
        console.error('URL inválida ou não encontrada.')
      }
    }
  },
  watch: {
    dialogPreview (val) {
      if (!val && this.previewFileUrl) {
        URL.revokeObjectURL(this.previewFileUrl)
        this.previewFileUrl = null
      }
    },
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    }
  }
}
</script>
